import { render, staticRenderFns } from "./tx.vue?vue&type=template&id=f6588c02&scoped=true&"
import script from "./tx.vue?vue&type=script&lang=js&"
export * from "./tx.vue?vue&type=script&lang=js&"
import style0 from "./tx.vue?vue&type=style&index=0&id=f6588c02&lang=scss&scoped=true&"
import style1 from "./tx.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6588c02",
  null
  
)

export default component.exports